/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'company-hub.spotlight-extension.config-panel.preamble':
    'Zvýrazněte důležitá sdělení pomocí vizuálního reflektoru. {supportLink}',
  'company-hub.spotlight-extension.config-panel.preamble-link.label': 'Další informace o reflektorech',
  'company-hub.spotlight-extension.config-panel.preamble-without-support-link':
    'Zvýrazněte důležitá sdělení pomocí vizuálního reflektoru.',
  'company-hub.spotlight-extension.config-panel.title': 'Reflektor',
  'company-hub.spotlight-extension.hub-element.description': 'Zvýrazněte důležité zprávy.',
  'company-hub.spotlight-extension.hub-element.title': 'Reflektor',
  'company-hub.spotlight-extension.manifest.initial-state.alt-image-text': 'Fotografie pouště na šířku',
  'company-hub.spotlight-extension.manifest.initial-state.text-description':
    'Navrhněte reflektor, který zvýrazní vaše nejdůležitější informace. Oživte své nejdůležitější zprávy pomocí vlastních barev, působivého obrázku a flexibilních rozvržení.',
  'company-hub.spotlight-extension.manifest.initial-state.text-title': 'Dejte svému reflektoru název',
  'company-hub.spotlight-extension.manifest.macro-description':
    'Zvýrazněte důležitá sdělení pomocí vizuálního reflektoru.',
  'company-hub.spotlight-extension.manifest.macro-title': 'Reflektor',
  'company-hub.spotlight-extension.manifest.macro-title.new': 'Reflektor [Nový]',
  'company-hub.spotlight-extension.spotlight-config-panel.content-tab.label': 'Obsah',
  'company-hub.spotlight-extension.spotlight-config-panel.general-title': 'Obecné',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts-title': 'Rozvržení',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.description':
    'Překrytí textového pole na velkém obrázku',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.label':
    'Obsahový snímek uvnitř obrázku',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.description':
    'Obrázek v plné velikosti za obsahem',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.label': 'Obrázek na pozadí',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.description':
    'Obsah před barvou na celou šířku',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.label': 'Jednobarevné pozadí',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.description':
    'Velký obrázek vpravo s velkým prostorem pro obsah',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.label':
    'Rozdělený design (nejprve obsah)',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.description':
    'Velký obrázek vlevo s velkým prostorem pro obsah',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.label':
    'Rozdělený design (nejprve obrázek)',
  'company-hub.spotlight-extension.spotlight-config-panel.styles-tab.label': 'Styly',
  'company-hub.spotlight-extension.spotlight-config-panel.text-description-label': 'Popis',
  'company-hub.spotlight-extension.spotlight-config-panel.text-description-placeholder':
    'Reflektory zvýrazňují důležité zprávy pro váš tým. Navrhněte si reflektor pomocí obrázku, vlastních barev, krátkého popisu a odkazu.',
  'company-hub.spotlight-extension.spotlight-config-panel.text-image-label': 'Obrázek',
  'company-hub.spotlight-extension.spotlight-config-panel.text-title-label': 'Název',
  'company-hub.spotlight-extension.spotlight-config-panel.text-title-placeholder': 'Dejte svému reflektoru název',
  'company-hub.spotlight-extension.spotlight.background.color': 'Barva pozadí',
  'company-hub.spotlight-extension.spotlight.color-contrast.fail':
    'Vaše kombinace barev textu a pozadí neposkytuje dobrou čitelnost.',
  'company-hub.spotlight-extension.spotlight.color-contrast.success':
    'Vaše kombinace barev textu a pozadí poskytuje dobrou čitelnost.',
  'company-hub.spotlight-extension.spotlight.text.color': 'Barva textu',
};
